import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function ProcedureCodeEditTemplate({ procedureCodeEditViewStore }) {
    const {
        contentLoading,
        form
    } = procedureCodeEditViewStore;

    return (
        <ApplicationEditLayout store={procedureCodeEditViewStore}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-8 col-lrg-7">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-3 u-mar--bottom--sml">
                                    <BasicInput field={form.$('name')} />
                                </div>
                                <div className="form__group col col-lrg-9 u-mar--bottom--sml">
                                    <BasicInput field={form.$('description')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

ProcedureCodeEditTemplate.propTypes = {
    procedureCodeEditViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ProcedureCodeEditTemplate);
